var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-progress-circular',{staticClass:"mr-2 ml-2",attrs:{"indeterminate":"","size":"20","color":_vm.propsColor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }